
export const months = [
    { name: 'Enero', number: 1 },
    { name: 'Febrero', number: 2 },
    { name: 'Marzo', number: 3 },
    { name: 'Abril', number: 4 },
    { name: 'Mayo', number: 5 },
    { name: 'Junio', number: 6 },
    { name: 'Julio', number: 7 },
    { name: 'Agosto', number: 8 },
    { name: 'Septiembre', number: 9 },
    { name: 'Octubre', number: 10 },
    { name: 'Noviembre', number: 11 },
    { name: 'Diciembre', number: 12 },
];

  
export const obtenerNombrePeriodo = (
    periodo: string | number | null | undefined
  ): string => {
    if (periodo === null || periodo === undefined || periodo === '') {
        return '';
    }
  
    const valor = String(periodo).trim().toUpperCase();
    const mesNumero = Number(valor);
  
    if (Number.isFinite(mesNumero) && mesNumero >= 1 && mesNumero <= 12) {
        const mes = months.find((dato) => dato.number === mesNumero);
        return mes?.name ?? `Mes ${mesNumero}`;
    }
  
    const trimestre = valor.match(/^([1-4])T$|^T([1-4])$/);
    if (trimestre) {
        const numeroTrimestre = Number(trimestre[1] ?? trimestre[2]);
        if (numeroTrimestre === 1) return 'I Trimestre (Ene–Mar)';
        if (numeroTrimestre === 2) return 'II Trimestre (Abr–Jun)';
        if (numeroTrimestre === 3) return 'III Trimestre (Jul–Sep)';
        return 'IV Trimestre (Oct–Dic)';
    }
  
    const semestre = valor.match(/^([1-2])S$|^S([1-2])$/);
    if (semestre) {
        const numeroSemestre = Number(semestre[1] ?? semestre[2]);
        return numeroSemestre === 1
            ? 'I Semestre (Ene–Jun)'
            : 'II Semestre (Jul–Dic)';
    }
  
    return valor;
  };

/**
 * Construye el valor del `periodo` con la convención usada por el backend.
 * Ejemplos:
 * - `construirPeriodoReporte(3, 'Marzo')` => `3`
 * - `construirPeriodoReporte(2, 'II Trimestre (Abr-Jun)')` => `T2`
 * - `construirPeriodoReporte(1, 'I Semestre (Ene-Jun)')` => `S1`
 */
export const construirPeriodoReporte = (
    monthNumber: number | string,
    monthLabel: string | null | undefined
): number | string => {
    const numeroPeriodo = Number(monthNumber);
    const nombrePeriodo = (monthLabel || '').toLowerCase();

    if (!Number.isFinite(numeroPeriodo)) {
        return monthNumber;
    }
    if (nombrePeriodo.includes('trimestre')) {
        return `T${numeroPeriodo}`;
    }
    if (nombrePeriodo.includes('semestre')) {
        return `S${numeroPeriodo}`;
    }
    return numeroPeriodo;
};

/**
 * Convierte una fecha local a ISO `yyyy-MM-dd` sin aplicar conversión UTC
 * (evita desfaces de un día al usar `toISOString()`).
 */
const toIsoLocal = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

/**
 * Último día del mes indicado (1–12) como ISO `yyyy-MM-dd`.
 * Si no se pasa `year`, usa el año actual.
 */
export const getMonthEndDate = (
    month: number,
    year: number = new Date().getFullYear()
): string => {
    if (!Number.isFinite(month) || month < 1 || month > 12) {
        return '';
    }
    // `new Date(y, m, 0)` devuelve el último día del mes `m` (1-based).
    return toIsoLocal(new Date(year, month, 0));
};

/**
 * Último día del trimestre indicado (1–4) como ISO `yyyy-MM-dd`.
 * Q1→Mar 31, Q2→Jun 30, Q3→Sep 30, Q4→Dic 31.
 */
export const getQuarterEndDate = (
    quarter: number,
    year: number = new Date().getFullYear()
): string => {
    if (!Number.isFinite(quarter) || quarter < 1 || quarter > 4) {
        return '';
    }
    const endMonth = quarter * 3; // 3, 6, 9, 12
    return toIsoLocal(new Date(year, endMonth, 0));
};

/**
 * Último día del semestre indicado (1–2) como ISO `yyyy-MM-dd`.
 * S1→Jun 30, S2→Dic 31.
 */
export const getSemesterEndDate = (
    semester: number,
    year: number = new Date().getFullYear()
): string => {
    if (semester !== 1 && semester !== 2) {
        return '';
    }
    const endMonth = semester === 1 ? 6 : 12;
    return toIsoLocal(new Date(year, endMonth, 0));
};